export default __webpack_public_path__ + "static/media/tb-demo.ec83d01f.gif";